
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type autoSyncVisualizationDialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function autoSyncVisualizationDialogRT(): TemplateResult<autoSyncVisualizationDialogRTRootProps> {
    return _createElement('div', { 'className': 'dialog-container' }, _createElement('div', {
        'className': 'close',
        'onClick': this.close
    }, _createElement('svg', {
        'className': 'cm_icon cm_icon-times',
        'height': '20px',
        'role': 'img',
        'viewBox': '0 0 22 22'
    }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))), _createElement('div', { 'className': 'dialog-content' }, [_createElement('div', {
            'className': 'cm_vehicle-visualization-container',
            'key': '2410'
        }, this.visualization)], this.isVehicleError ? _createElement('div', {
        'className': 'cm_vehicle-error',
        'key': '350'
    }, _translate(`autosync_visualizer_vehicle_error`)) : null, this.isVisualizationError ? _createElement('div', {
        'className': 'cm_visualization-error',
        'key': '469'
    }, '\n      ', _translate(`autosync_visualizer_part_error`), '\n    ') : null));
}
        export const componentNames = []